/* eslint-disable camelcase, no-param-reassign */
import React, { useState } from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  useBlocker,
  useNavigate,
} from 'react-router-dom';

import {
  Icon,
  Video,
  Button,
  Author,
  Tooltip,
  TextField,
  EditorField,
  ContentWrapper,
} from 'web-components';

import {
  Flex,
  TextBreadcrumbs,
} from 'web-styled';

import * as S from './styled';

type Props = {
  onRequestSubmit: { (values: any, actions: any): void },
};

const NewAnnouncement = ({ onRequestSubmit }: Props) => {
  const navigate = useNavigate();
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false);

  // Block navigating elsewhere when data has been entered into the input
  const blocker = useBlocker(({ currentLocation, nextLocation }) => (
    shouldBlockNavigation && currentLocation.pathname !== nextLocation.pathname));

  if (blocker.state === 'blocked') {
    const ask = window.confirm('Changes you made may not be saved.');

    if (ask) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }

  return (
    <ContentWrapper
      header={(
        <Flex align="center" spacing={10}>
          <Button
            appearance="link"
            onClick={() => {
              navigate(-1);
            }}
            noPrint
          >
            <Icon type="fa fa-chevron-left" />
          </Button>
          <TextBreadcrumbs>
            New Announcement
          </TextBreadcrumbs>
        </Flex>
      )}
    >
      <Formik
        initialValues={{
          title: '',
          description: '',
          video_id: '',
          video_url: '',
        }}
        onSubmit={onRequestSubmit}
      >
        {(formikProps) => (
          <S.Container
            onKeyPress={() => {
              setShouldBlockNavigation(true);
            }}
            spacing={30}
            onSubmit={(e: any) => {
              e.preventDefault();
              setShouldBlockNavigation(false);
              formikProps.handleSubmit(e);
            }}
          >
            <S.Header>
              <Flex align="center">
                <Author
                  fullName="Gym Cloud"
                />
              </Flex>
              <Flex align="center" spacing={10}>
                <Button
                  ghost
                  type="submit"
                  appearance="primary"
                  isLoading={formikProps.isSubmitting}
                  isDisabled={formikProps.isSubmitting}
                >
                  Send
                </Button>
                <Button
                  ghost
                  type="button"
                  appearance="danger"
                  onClick={() => {
                    navigate('/welcome');
                  }}
                >
                  Cancel
                </Button>
              </Flex>
            </S.Header>
            <S.Content>
              <Flex
                column
                flex="0 0 50%"
                align="center"
              >
                <Video
                  id={formikProps.values.video_id}
                  src={formikProps.values.video_url}
                  height="400px"
                  resourceType="announcement"
                  onAssign={(video) => {
                    setShouldBlockNavigation(true);
                    const id = video.embed_url.indexOf('vimeo') !== -1 ? video.id : null;
                    formikProps.setFieldValue('video_id', id);
                    formikProps.setFieldValue('video_url', video.embed_url);
                  }}
                  onDelete={() => {
                    setShouldBlockNavigation(true);
                    formikProps.setFieldValue('video_id', '');
                    formikProps.setFieldValue('video_url', '');
                  }}
                />
              </Flex>
              <Flex
                column
                spacing={30}
                flex="1 1 auto"
                padding="0 0 30px 0"
              >
                <Field
                  flex="0 0 60px"
                  name="title"
                  label="Title"
                  color="primary"
                  placeholder="Type announcement title here..."
                  component={TextField}
                />
                <Tooltip
                  body="Type the Announcement description here"
                  positions={['top']}
                >
                  <Flex width="100%">
                    <Field
                      name="description"
                      color="primary"
                      label="Description"
                      placeholder="Type announcement description here..."
                      component={EditorField}
                    />
                  </Flex>
                </Tooltip>
              </Flex>
            </S.Content>
          </S.Container>
        )}
      </Formik>
    </ContentWrapper>
  );
};

export default NewAnnouncement;
